// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3UwGT","amount":"Amount_amount__1Go2m","tip":"Amount_tip__20AJ2","tipHeader":"Amount_tipHeader__2WDis","tipsWrap":"Amount_tipsWrap__gISJS"};